// extracted by mini-css-extract-plugin
export default {"detail":"TransactionDetail_detail__uJ2HE","label":"TransactionDetail_label__Kw4kj","title":"TransactionDetail_title__iJsAX"};